import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationStatistics(): TFunction {
  const { t } = useTranslation(Domain.STATISTICS);

  return t;
}

export default useTranslationStatistics;
